export default __webpack_public_path__ + "static/media/002-alarm clock.b80e9c29.svg";